import {Injectable, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {UserSettingsService} from "./user.settings.service";
import {ThemeMode} from "../../../shared/client.settings";

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private mediaQuery: MediaQueryList | null = null;
    private mediaQueryListener: ((event: MediaQueryListEvent) => void) | null = null;

    constructor(@Inject(DOCUMENT) private readonly document: Document, private _userSettingsService: UserSettingsService) {
        this._userSettingsService.themeChanged.subscribe((mode) => {
            this.applyMode(mode);
        });
    }

    get mode(): ThemeMode {
        return this._userSettingsService.themeMode;
    }

    init() {
        this.applyMode(this._userSettingsService.themeMode);
    }

    setMode(mode: ThemeMode) {
        this._userSettingsService.themeMode = mode;
    }

    private applyMode(mode: ThemeMode) {
        this.detachMediaListener();

        if (mode === 'system') {
            if (typeof window === 'undefined') {
                return;
            }
            this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            this.applyDarkClass(this.mediaQuery.matches);
            this.mediaQueryListener = (event: MediaQueryListEvent) => {
                this.applyDarkClass(event.matches);
            };

            if (this.mediaQuery.addEventListener) {
                this.mediaQuery.addEventListener('change', this.mediaQueryListener);
            } else if (this.mediaQuery.addListener) {
                this.mediaQuery.addListener(this.mediaQueryListener);
            }
            return;
        }

        this.applyDarkClass(mode === 'dark');
    }

    private detachMediaListener() {
        if (!this.mediaQuery || !this.mediaQueryListener) {
            this.mediaQuery = null;
            this.mediaQueryListener = null;
            return;
        }

        if (this.mediaQuery.removeEventListener) {
            this.mediaQuery.removeEventListener('change', this.mediaQueryListener);
        } else if (this.mediaQuery.removeListener) {
            this.mediaQuery.removeListener(this.mediaQueryListener);
        }

        this.mediaQuery = null;
        this.mediaQueryListener = null;
    }

    private applyDarkClass(isDark: boolean) {
        const element = this.document.documentElement;
        if (element) {
            element.classList.toggle('theme-dark', isDark);
        }
    }
}
